import { render } from "./BadFood.vue?vue&type=template&id=1a97cfe1&scoped=true"
import script from "./BadFood.vue?vue&type=script&lang=js"
export * from "./BadFood.vue?vue&type=script&lang=js"

import "./BadFood.vue?vue&type=style&index=0&id=1a97cfe1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a97cfe1"]])

export default __exports__